export default {
  name: '表单',
  label: {
    formItemName: '表单元素',
    submitBtnContent: '提交按钮',
    submitUrl: '提交路径',
    itemType: '元素类型',
    option: '选项',
    link: '协议超链接',
    linkTip: '附件',
    isRequired: '是否必填',
    clickUpload: '上传',
    attachment: '附件',
    url: '链接',
    uploadTips: '可以上传PDF/HTML/文档/图片文件，大小不超过{maxSize}MB!',
    openAfterSubmit: '提交后跳转'
  },
  placeholder: {
    submitBtnContent: '请输入提交按钮文案',
    submitUrl: '请输入表单提交路径(默认提交至Ajinga，Ajinga提供数据导出)',
    itemType: '请选择元素类型',
    option: '选项1\n选项2\n选项3\n...等',
    link: '请输入协议超链接',
    selectDate: '请选择日期',
    location: '请选择地区',
    country: '国家/地区',
    province: '省/州',
    city: '市/镇',
    select: '请选择'
  },
  message: {
    titleRequired: '表单标题是必填的。',
    buttonContentRequired: '提交按钮文案是必填的。',
    optionRequired: '选项是必填的。',
    linkRequired: '至少提供一个链接。',
    isRequired: '该字段不能为空',
    locationRequired: '请选择地址',
    policyLinkRequired: '请同意以上条款再继续'
  }
}
